import { Component, Input, OnInit } from '@angular/core';
import { Order } from '@vendasta/sales-orders';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OrderDetailField } from '@vendasta/sales-ui';
import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BuildDetailNamePipe } from './build-detail-name.pipe';
import { BuildDetailValuePipe } from './build-detail-value.pipe';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';

@Component({
  selector: 'orders-order-activity',
  imports: [
    NgClass,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    GalaxyBadgeModule,
    MatExpansionModule,
    TranslateModule,
    BuildDetailNamePipe,
    BuildDetailValuePipe,
    AsyncPipe,
    NgTemplateOutlet,
  ],
  templateUrl: './order-activity.component.html',
  styleUrls: ['./order-activity.component.scss'],
  providers: [TranslateService],
  standalone: true,
})
export class OrderActivityComponent implements OnInit {
  @Input() order$!: Observable<Order>;
  orderDetailFields$: Observable<OrderDetailField[]>;

  constructor(private translateService: TranslateService) {}
  ngOnInit(): void {
    this.orderDetailFields$ = this.order$.pipe(
      map((salesOrder) => OrderDetailField.createFromOrderWithUsers(salesOrder, {})),
    );
  }

  protected activityTrackIndex(index: number, item: OrderDetailField) {
    return `${index}-${item.status}`;
  }
}
